import { useSelector } from "react-redux";
import type { RootState } from "../../../../../../../../redux/store";
import { getTicketDetailsRightSidebarItems } from "../../utils/constants";
import { ActivityContent } from "./components/Activity/ActivityContent";
import TicketAiSummary from "./components/TicketAiSummary/TicketAiSummary";
import TicketAttachments from "./components/TicketAttachments";
import TicketLogs from "./components/TicketLogs";
import TicketDetailsContent from "./components/TicketDetailsContent";
import { HelpdeskStage, TicketData } from "../../../../utils/types";

interface RightPanelProps {
  activeTab: string;
  ticketData?: TicketData;
  isTicketLoading?: boolean;
  stagesData?: HelpdeskStage[];
}

export const RightPanel = ({
  activeTab,
  ticketData,
  isTicketLoading,
  stagesData,
}: RightPanelProps) => {
  const region = useSelector(
    (state: RootState) => state?.auth?.client?.region
  );
  const sidebarItems = getTicketDetailsRightSidebarItems(region);
  const currentTab = sidebarItems?.find(
    (item) => item?.id === activeTab
  );

  const ticketCreatedById =
    typeof ticketData?.created_by === "object"
      ? ticketData?.created_by?.id
      : ticketData?.created_by;

  const renderContent = () => {
    switch (activeTab) {
      case "activity":
        return (
          <ActivityContent
            ticketId={ticketData?.ticket_id}
            assignees={ticketData?.assignees}
            ticketCategory={ticketData?.ticket_category}
            ticketCreatedById={ticketCreatedById}
          />
        );
      case "ai-summary":
        return (
          <TicketAiSummary
            ticketId={ticketData?.ticket_id}
            aiSummary={ticketData?.ai_summary}
            isLoading={Boolean(isTicketLoading && ticketData === undefined)}
          />
        );
      case "attachments":
        return <TicketAttachments />;
      case "logs":
        return (
          <TicketLogs
            activityLogs={ticketData?.activity_logs}
            isLoading={Boolean(isTicketLoading && ticketData === undefined)}
            stages={stagesData}
          />
        );
      case "details":
        return (
          <TicketDetailsContent
            ticketData={ticketData}
            isLoading={Boolean(isTicketLoading && ticketData === undefined)}
          />
        );
      default:
        return (
          <>
            <div className="flex items-center h-[50px] px-4 border-b border-border-gray dark:border-border-gray-dk bg-pure-white dark:bg-pure-white-dk">
              <h3 className="text-md font-semibold text-verba-indigo dark:text-verba-indigo-dk">
                {currentTab?.panelTitle || ""}
              </h3>
            </div>
            <div className="flex-1 p-4 overflow-y-auto">
              <p className="text-sm text-gray-placeholder dark:text-gray-placeholder-dk">
                Content for {currentTab?.panelTitle || ""} will be displayed
                here
              </p>
            </div>
          </>
        );
    }
  };

  return (
    <div className="flex flex-col w-[325px] shrink-0 h-full border-l border-border-gray dark:border-border-gray-dk bg-pure-white dark:bg-pure-white-dk">
      {renderContent()}
    </div>
  );
};
